"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CallbackForm = require("./CallbackForm");
Object.keys(_CallbackForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CallbackForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CallbackForm[key];
    }
  });
});